export default __webpack_public_path__ + "static/media/ThreeDotLoader.8bb5967e.gif";